"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ZMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_256)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_256`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-12 -0.00012207H24.0001V24.0002H-12V-0.00012207Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.5002 7.74439H19.1252C19.1252 7.1231 18.6214 6.61938 18.0002 6.61938C17.3789 6.61938 16.8752 7.1231 16.8752 7.74439H13.5002C13.5002 8.36567 14.0413 8.86939 14.6626 8.86939H14.6252C14.6252 9.49067 15.1287 9.99439 15.7502 9.99439C15.7502 10.6157 16.2537 11.1194 16.8752 11.1194H19.1252C19.7464 11.1194 20.2502 10.6157 20.2502 9.99439C20.8714 9.99439 21.3752 9.49067 21.3752 8.86939H21.3377C21.959 8.86939 22.5002 8.36567 22.5002 7.74439Z",
					fill: "#FF9811"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0003 11.9996H16.0002V23.9994H12.0003V11.9996Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.0001 11.9996H24.0001V23.9994H20.0001V11.9996Z",
					fill: "#FF9811"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.0002 11.9996H20.0002V23.9994H16.0002V11.9996Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_256`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ZMFlag };
